import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from 'src/app/_store/config';

export interface VendorData {
  supplierNm: string;
  dbaNm: string;
  businessType: string;
  federalTaxClassification: string;
  federalTaxId: string;
  dunsNo: string;
  businessStartDate: string;
  naicsNo: string;
  webUrl: string;
  primaryContact: string;
  mobile: string;
  email: string;
  addrLine1: string;
  addrLine2: string;
  taxCompliance: {
    stateTaxId: string;
    permitNo: string;
    certifications: string;
    complianceAgreements: string;
  };
  bankDetails: {
    bankName: string;
    accountNo: string;
    IFSC: string;
    acType: string;
    paymentMethodPreference: string;
    remiEmail: string;
  };
  supportingDoc: Array<{
    type: string;
    filename: string;
  }>;
  insurance: {
    license: string;
    certificates: string;
    expDate: string;
  };
  erpSupplierId: string;
  goodsCat: string;
  serviceRegions: string;
  certificationStatus: string;
  termsAgreement: string;
}

export interface VendorRegistrationRequest {
  action: string;
  supplier: VendorData[];
}

export interface DocumentUploadResponse {
  success: boolean;
  message: string;
  filename?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VendorRegistrationService {

  constructor(private http: HttpClient) { }

  registerVendor(vendorData: VendorData): Observable<any> {
    const requestBody: VendorRegistrationRequest = {
      action: 'register',
      supplier: [vendorData]
    };

    return this.http.post(Config.urls.REGISTER_VENDOR, requestBody);
  }

  uploadDocument(file: File) {
    const formData = new FormData();
    formData.append('sellerCode', 'GarageCo');
    formData.append('type', 'IRSW-9');
    formData.append('file', file, file.name);

    return this.http.post(Config.urls.UPLOAD_DOCS,formData);
  }

  // getVendorStatus(vendorId: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': this.AUTH_HEADER
  //   });

  //   return this.http.get(`${this.API_BASE_URL}/supplier/${vendorId}/status`, { headers });
  // }

}

